export class RenewingTokenFailed{
    static $type = 'SAM.Workflow.Core.ExceptionMessages.RenewingTokenFailed, SAM.Workflow.Core';

    toString(){
        return 'Authentication token cannot be renewed at this time.';
    }
}